import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import CustomReveal from './../../common/reveal/CustomReveal';
import { SmartButton } from '../../common/SmartButton';
import CustomIcon from '../../../components/common/CustomIcon';
import { I18n } from 'react-redux-i18n-lite';
import * as revealActions from '../../../actions/revealActions';
import { bindActionCreators } from 'redux';

class AssignmentsContentPanelModalNoGroups extends React.Component {
  static propTypes = {
    revealActions: PropTypes.any,
    assignmentsDrawerActions: PropTypes.any,
    students: PropTypes.array,
    taskActions: PropTypes.any
  };

  closeModal = () => {
    this.props.revealActions.openTaskWithoutStudentsOfThisGroup(false);
  };

  render() {
    return (
      <CustomReveal id="not-exist-group-in-units" active close={this.closeModal}>
        <div className="parent">
          <div className="header">
            <span className="close-btn" onClick={this.closeModal}>
              <CustomIcon name="close-button" size={24} />
            </span>
          </div>

          <div className="content">
            <span className="span-content">{I18n.t('tskWithoutStudentsOfThisGroup.description')}</span>
          </div>

          <div className="footer">
            <div className="footer-content">
              <SmartButton onClick={this.closeModal}>{I18n.t('common.close')}</SmartButton>
            </div>
          </div>
        </div>
      </CustomReveal>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    revealActions: bindActionCreators(revealActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    open: state.reveal.open
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentsContentPanelModalNoGroups);
